import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { useLang } from '../../../context/LangContext';
import { fadeInUp } from '../../../animations/variants';

const faqKeys = [1, 2, 3, 4, 5, 6, 7, 8];

export const FAQ = () => {
  const { t } = useLang();
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section data-testid="faq-section" className="relative py-24 md:py-32 bg-[#020209]">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <motion.div {...fadeInUp} className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight">
            {t("faq.title")}
          </h2>
        </motion.div>

        <div className="space-y-0">
          {faqKeys.map((num, i) => {
            const isOpen = openIndex === i;
            return (
              <motion.div
                key={num}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05, type: "spring", stiffness: 55, damping: 18 }}
                className="border-b border-neutral-800"
              >
                <button
                  data-testid={`faq-item-${i}`}
                  className="w-full flex items-center justify-between py-5 text-left group"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                >
                  <span className="text-sm md:text-base font-medium text-white group-hover:text-brand-green transition-colors pr-4">
                    {t(`faq.${num}.q`)}
                  </span>
                  <motion.div
                    animate={{ rotate: isOpen ? 180 : 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <ChevronDown size={18} className="text-neutral-500 flex-shrink-0" />
                  </motion.div>
                </button>
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <p className="text-sm text-neutral-400 leading-relaxed pb-5">
                        {t(`faq.${num}.a`)}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
